export class UsuarioOAuthKC {
    sub!: string;
    email_verified!: string;
    name!: string;
    preferred_username!: string;
    given_name!: string;
    family_name!: string;
    email!: string;
}